export const whitelabel = {
  plans: 'Planer',
  managePlan: 'Hantera Planer',
  whitelabelCharges: 'Whitelabel Avgifter',
  chargesOrTaxesConfiguration: 'Avgifter/Skattkonfiguration',
  websitePlans: 'Webbplatsplaner',
  whatsappPlansHeader: 'WhatsApp Planer',
  addOnPlans: {
    createAddOnPlans: 'Skapa Tilläggsplaner',
    checkoutYourCurrentMessage: 'Kolla in dina nuvarande meddelande-tilläggsplaner och nya planer för dina kunder',
    choosePlanValidity: 'Välj Planens Giltighet',
    chooseValidity: 'Välj Giltighet',
    oneYear: 'Ett år',
    billingCycle: 'Faktureringscykel',
    numberOfMessages: 'Antal meddelanden',
    pleaseEnterNumberOfMessages: 'Ange antal meddelanden',
    setCurrency: 'Ange valuta',
    select: 'Välj',
    inr: 'INR',
    usd: 'USD',
    cad: 'CAD',
    clearAll: 'Rensa allt',
    apply: 'Tillämpa',
    currency: 'Valuta',
    amount: 'Belopp',
    validity: 'Giltighet',
    upgradePlan: 'Uppdatera Plan',
    addPlan: 'Lägg till Plan',
    serialNumber: 'Serienummer',
    messages: 'Meddelanden',
    // validity: 'Giltighet',
    active: 'Aktiv',
    priceDetails: 'Prisinformation',
    action: 'Åtgärd',
    addOnChanges: 'Tilläggskostnader: ',
    // messages: ' Meddelanden',
    perYear: 'per År',
    taxes: 'Skatter',
    placeholders: {
      enterNumberOfMesasges: 'Ange antal meddelanden',
      enterAmount: 'Ange Belopp',
      enterValidity: 'Ange Giltighet',
      searchByMessages: 'Sök efter Meddelanden'
    },
    modal: {
      deleteAddOnsPlan: 'Radera Tilläggsplan',
      wantToDeleteThisAddOnsPlan: 'Är du säker på att du vill radera denna Tilläggsplan?',
    }
  },
  charges: {
    addWhitelabelCharges: 'Lägg till WhiteLabel-avgifter',
    checkoutExistingCharges: 'Kolla in befintliga avgifter på olika betalningsmetoder och lägg till nya whitelabel-avgifter',
    currency: 'Valuta',
    chooseCurrency: 'Välj Valuta',
    amountPerBotPerMonth: 'Belopp per bot per månad',
    cancel: 'Avbryt',
    upgradeChanges: 'Uppdatera Avgifter',
    addCharges: 'Lägg till Avgifter',
    serialNumber: 'Serienummer',
    // currency: 'Valuta',
    action: 'Åtgärd',
    taxes: 'Skatter',
    placeholders: {
      enterAmountBotPerMonth: 'Ange belopp bot per månad',
      searchByCurrency: 'Sök efter Valuta',
    },
    modal: {
      deleteCharges: 'Radera Avgifter',
      wantToDeleteThisCharge: 'Är du säker på att du vill radera denna avgift?',
    }
  },
  planManagement: {
    createNewPlans: 'Skapa nya planer',
    checkoutYourCurrentPlan: 'Kolla in dina nuvarande planer och lägg till nya planer för dina kunder',
    choosePlan: 'Välj Plan',
    selectPlan: 'Välj Plan',
    baby: 'Baby',
    king: 'Kung',
    displayName: 'Visningsnamn',
    messageLimit: 'Meddelandegräns',
    enterAValidEmail: 'Ange en giltig e-postadress',
    setCurrency: 'Ange valuta',
    select: 'Välj',
    inr: 'INR',
    usd: 'USD',
    cad: 'CAD',
    clearAll: 'Rensa allt',
    apply: 'Tillämpa',
    perMonth: '/Månad',
    perYear: '/År',
    cancel: 'Avbryt',
    upgradePlan: 'Uppdatera Plan',
    addPlan: 'Lägg till Plan',
    serialNumber: 'Serienummer',
    plan: ' Plan',
    // displayName: 'Visningsnamn',
    messages: 'Meddelanden',
    pricing: 'Prissättning',
    actions: 'Åtgärder',
    // plan: ' Plan',
    perMonthText: 'Per Månad',
    perYearText: 'Per År',
    placeholders: {
      enterDisplayName: 'Ange visningsnamn',
      enterMessageLimit: 'Ange meddelandegräns',
      searchByPlanName: 'Sök efter Planens Namn eller Meddelanden',
    },
    modal: {
      deletePlan: 'Radera Plan',
      wantToDeleteThisBabyPlan : 'Att radera Baby-planen kommer att påverka alla kunder. Är du säker på att du vill radera denna plan?',
      wantToDeleteThisPlan: 'Är du säker på att du vill radera denna plan?',
    },
    appTooltip: {
      chooseYourPlanType: 'Välj din plan',
      pleaseInputYourPlanDisplayName: 'Ange visningsnamn för din plan',
      typeMessageLimitForCustomer: 'Ange meddelandegräns för kunden',
      selectYourPreferredCurrencies: 'Välj dina föredragna valutor',
    }
  },
  taxesConfiguration: {
    addTaxes: 'Lägg till Skatter',
    checkoutExistingTaxes: 'Kolla in befintliga skatter på olika betalningsmetoder och nya skatter',
    taxName: 'Skattenamn',
    applicableOn: 'Tillämplig på',
    choosePlans: 'Välj Planer',
    chooseCurrency: 'Välj Valuta',
    percentage: 'Procent',
    cancel: 'Avbryt',
    // addTaxes: 'Lägg till Skatter',
    serialNumber: 'Serienummer',
    name: 'namn',
    // percentage: 'Procent',
    currency: 'Valuta',
    updateTaxes: 'Uppdatera Skatter',
    actions: 'Åtgärder',
    modal: {
      deleteTaxes: 'Radera Skatter',
      wantToDeleteThisTax: 'Är du säker på att du vill radera dessa skatter?',
    },
    placeholders: {
      taxName: 'Skattenamn',
      taxPercentage: 'Skatteprocent',
      searchByCurrency: 'Sök efter Valuta',
    }
  },
  whatsappPlans: {
    createNewPlans: 'Skapa nya planer',
    checkoutYourCurrentAndNewPlans: 'Kolla in dina nuvarande planer och lägg till nya planer för dina kunder',
    choosePlan: 'Välj Plan',
    selectPlan: 'Välj Plan',
    baby: 'Baby',
    king: 'Kung',
    displayName: 'Visningsnamn',
    messageLimit: 'Samtalsgräns',
    enterAValidMessageLimit: 'Ange en giltig samtalgräns',
    setCurrency: 'Ange valuta',
    select: 'Välj',
    inr: 'INR',
    usd: 'USD',
    cad: 'CAD',
    clearAll: 'Rensa allt',
    apply: 'Tillämpa',
    perMonth: '/Månad',
    perYear: '/År',
    cancel: 'Avbryt',
    addPlan: 'Lägg till Plan',
    serialNumber: 'Serienummer',
    plan: 'Plan',
    messages: 'Samtal',
    pricing: 'Prissättning',
    actions: 'Åtgärder',
    perMonthText: 'Per Månad',
    perYearText: 'Per År',
    updatePlan: 'Uppdatera Plan',
    // addPlan: 'Lägg till Plan',
    placeholders: {
      enterDisplayName: 'Ange visningsnamn',
      enterMessageLimit: 'Ange samtalgräns',
      searchByPlanName: 'Sök efter Planens Namn eller Samtal',
    },
    appTooltip: {
      typeMessageLimitForCustomer: 'Ange samtalgräns för kunden',
      chooseYourPlanType: 'Välj din plan',
      selectYourPreferredCurrencies: 'Välj dina föredragna valutor',
      pleaseInputYourPlanDisplayName: 'Ange visningsnamn för din plan',
    },
    modal: {
      deletePlan: 'Radera Plan',
      areYouSureYouWantToDeleteThisPlan: 'Är du säker på att du vill radera denna plan?',
      wantToDeleteThisBabyPlan : 'Att radera Baby-planen kommer att påverka alla kunder. Är du säker på att du vill radera denna plan?',
    }
  }
};
